// src/App.jsx
import React from "react";
import { ThemeProvider } from "./context/ThemeContext";
import Layout from "./components/Layout";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./index.css";
import HomePage from "./pages/HomePage/HomePage";
import LoginPage from "./pages/LoginPage/LoginPage";
import Quiz from "./pages/Quiz";
import Result from "./pages/Result";
import QuestionGenerator from "./pages/QuestionGenerator/QuestionGenerator";
import Learner from "./pages/Learner/Learner";
import Record from "./pages/Record/Record";
import Setting from "./pages/Setting/Setting";
import LearnerHomePage from "./pages/LearnerHomePage/LearnerHomePage";
import { Navigate } from "react-router-dom";


const ProtectedRoute = ({ children, allowedRoles }) => {
    const userRole = localStorage.getItem("userRole");

    if (!allowedRoles.includes(userRole)) {
        return <Navigate to="/login" />;
    }

    return children;
};

const App = () => (
    <ThemeProvider>
        <Router>
            <Routes>
                {/* Define a separate route for the Login page */}
                <Route path="/" element={<HomePage />} />
                <Route path="/login" element={<LoginPage />} />
                <Route path="/quiz/:quizId" element={<Quiz />} />
                <Route path="/result/:sessionId" element={<ProtectedRoute allowedRoles={["learner"]}><Result /></ProtectedRoute>} />
                <Route path="/learner" element={<ProtectedRoute allowedRoles={["learner"]}><LearnerHomePage /></ProtectedRoute>} />

                {/* All other routes will use the Layout */}
                <Route element={<Layout />}>
                    <Route path="/question-creator" element={<ProtectedRoute allowedRoles={["tutor"]}><QuestionGenerator /></ProtectedRoute>} />
                    <Route path="/learners" element={<ProtectedRoute allowedRoles={["tutor"]}><Learner /></ProtectedRoute>} />
                    <Route path="/record" element={<ProtectedRoute allowedRoles={["tutor"]}><Record /></ProtectedRoute>} />
                    <Route path="/setting" element={<ProtectedRoute allowedRoles={["tutor"]}><Setting /></ProtectedRoute>} />
                </Route>
            </Routes>
        </Router>
    </ThemeProvider>
);

export default App;
